const LK_Refresh =({color,width,height})=>{
    return(
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81 81" fill={color} width={width} height={height}>
            {/*  <defs>
                <style>
                .cls-1 {
                    fill: #005c8b;
                }
                </style>
            </defs> 
            */}
            <path class="cls-1" d="M1.86,52.75l-.4-1.43c-.97-3.51-1.46-7.15-1.46-10.82C0,18.17,18.17,0,40.5,0c8.81,0,17.43,2.9,24.43,8.2l7.74-6.5.71,23.54-23.07-4.78,7.51-6.3c-5.14-3.38-11.08-5.16-17.31-5.16-17.37,0-31.5,14.13-31.5,31.5,0,2.88.39,5.73,1.15,8.47l.41,1.46-8.7,2.33ZM40.5,3C19.82,3,3,19.82,3,40.5c0,2.9.33,5.78.99,8.58l2.9-.78c-.59-2.54-.89-5.16-.89-7.8C6,21.48,21.48,6,40.5,6c7.52,0,14.67,2.37,20.67,6.86l1.52,1.13-5.71,4.79,13.29,2.75-.41-13.56-4.88,4.09-.96-.78c-6.63-5.35-14.98-8.3-23.52-8.3Z"/>
            <path class="cls-1" d="M40.5,81c-8.8,0-17.43-2.9-24.43-8.2l-7.74,6.5-.7-23.55,23.06,4.79-7.5,6.29c5.13,3.39,11.08,5.17,17.3,5.17,17.37,0,31.5-14.13,31.5-31.5,0-3-.42-5.97-1.26-8.83l-.43-1.47,8.7-2.33.41,1.41c1.05,3.63,1.58,7.4,1.58,11.22,0,22.33-18.17,40.5-40.5,40.5ZM16.02,68.93l.96.78c6.63,5.35,14.98,8.3,23.52,8.3,20.68,0,37.5-16.82,37.5-37.5,0-3.04-.36-6.05-1.08-8.96l-2.9.78c.65,2.67.98,5.42.98,8.19,0,19.02-15.48,34.5-34.5,34.5-7.52,0-14.66-2.38-20.66-6.87l-1.51-1.13,5.7-4.78-13.28-2.75.4,13.55,4.87-4.09Z"/>
        </svg>
    );
};

export default LK_Refresh;